var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.947762,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#37828B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4478 15.3542C24.1807 14.5238 25.2531 14 26.4478 14C28.6569 14 30.4478 15.7909 30.4478 18C30.4478 20.2091 28.6569 22 26.4478 22C25.2531 22 24.1807 21.4762 23.4478 20.6458M26.4478 32H14.4478V31C14.4478 27.6863 17.134 25 20.4478 25C23.7615 25 26.4478 27.6863 26.4478 31V32ZM26.4478 32H32.4478V31C32.4478 27.6863 29.7615 25 26.4478 25C25.3549 25 24.3303 25.2922 23.4478 25.8027M24.4478 18C24.4478 20.2091 22.6569 22 20.4478 22C18.2386 22 16.4478 20.2091 16.4478 18C16.4478 15.7909 18.2386 14 20.4478 14C22.6569 14 24.4478 15.7909 24.4478 18Z",
    stroke: "#37828B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/Total Users.a302283d.svg";
export { ForwardRef as ReactComponent };